import PropertyCard from "../../components/properties/PropertyCard";
import PropertyFormModal from "../../components/properties/PropertyFormModal";
import { useAgentStore } from "../../store/agentStore";
import { usePropertiesByAgentQuery } from "../../queries/properties/usePropertiesQuery";
import { useAuthStore } from "../../store/authStore";

import "../../styles/properties.css";

export default function Properties({ agentId }) {
  const { role } = useAuthStore();
  const isAdmin = role === "admin";

  const { selectedAgent } = useAgentStore();

  const agentIdForQuery = isAdmin ? agentId : null;
  const { data: propertiesData = [], isLoading: propertiesLoading } =
    usePropertiesByAgentQuery(agentIdForQuery);

  const properties = isAdmin ? propertiesData : selectedAgent?.properties || [];

  if (propertiesLoading) return <div>Loading...</div>;

  const propertiesDisplay =
    properties.length > 0 ? (
      properties.map((property) => (
        <PropertyCard key={property.id} property={property} />
      ))
    ) : (
      <div className="text-center text-gray-500">No properties found</div>
    );

  return (
    <>
      <section className="properties-page mx-0">{propertiesDisplay}</section>
      <PropertyFormModal agentId={agentId} />
    </>
  );
}
